import React, { useEffect, useState } from 'react'
import {
  Modal, Form, Input, message, Spin,
} from 'antd'

import { fetch } from '../../../utils/fetch'

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
}

const ModalRemark = ({
  visibleRemark,
  orderId,
  referenceData,
  onSuccess,
  onCancel,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({ ...referenceData })
  }, [visibleRemark])

  const updateRemarkOrderItem = (values) => {
    fetch({
      method: 'PUT',
      url: `/order/${orderId}/item/remark`,
      data: {
        referenceCode: values.referenceCode?.trim(),
        remark: values.remark?.trim(),
      },
    }).then((res) => {
      if (res?.data?.success) {
        form.resetFields()
        message.success('remark updated.')
        setIsLoading(false)
        onSuccess(values)
      } else {
        message.error(res?.data?.message)
        setIsLoading(false)
      }
    })
  }

  const cancelModal = () => {
    form.resetFields()
    onCancel()
  }

  return (

    <Modal
      title={`Remark Order ID: ${orderId}`}
      visible={visibleRemark}
      maskClosable={false}
      okText="Submit"
      cancelText="Cancel"
      onCancel={cancelModal}
      okButtonProps={{
        disabled: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
      onOk={() => {
        setIsLoading(true)
        form
          .validateFields()
          .then((values) => {
            updateRemarkOrderItem(values)
          })
          .catch((info) => {
            setIsLoading(false)
            console.log('Validate Remark Failed:', info)
          })
      }}
    >
      <Spin spinning={isLoading}>
        <Form
          {...layout}
          form={form}
          name="order_item_remark_form"
          layout="horizontal"
          preserve={false}
        >
          <Form.Item
            name="referenceCode"
            label="Ref No."
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="remark"
            label="Remark"
          >
            <Input
              placeholder="Input SO Number"
              allowClear
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>

  )
}

export default ModalRemark
